
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/wireline",
      function () {
        return require("private-next-pages/expertise/wireline.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/wireline"])
      });
    }
  